/* istanbul ignore file */
import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
	selector: 'vp-sheet-content, [vp-sheet-content], [vpSheetContent]',
	standalone: false,
})
export class SheetContentDirective {
	readonly elementRef = inject(ElementRef);

	constructor() {
		this.elementRef.nativeElement.classList.add(
			'overflow-y-auto',
			'block',
			'will-change-scroll',
			'p-4',
			'sm:p-6',
		);
	}
}

@Directive({
	selector: 'vp-sheet-header, [vp-sheet-header], [vpSheetHeader]',
	standalone: false,
})
export class SheetHeaderDirective {
	readonly elementRef = inject(ElementRef);

	constructor() {
		this.elementRef.nativeElement.classList.add(
			'flex-1',
			'children:mb-0',
			'children:text-lg',
			'children:font-semibold',
			'children:text-dark-primary',
		);
	}
}
